export enum ConfirmationStatus {
  Positive = 'positive',
  Negative = 'negative',
}

export type RJCommHubCandidateConfirmationProps = {
  status?: ConfirmationStatus;
};

export type RJCommHubCandidateConfirmationStyleProps = {
  status: ConfirmationStatus;
};
